import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getRoleType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}role/type/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addRoleType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}role/type/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getByIdRoleType(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}role/type/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateRoleType(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}role/type/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
